( ( $ ) => {
	const modal = $( '#js-unshippable-modal' );

	if ( modal.length === 0 ) {
		return;
	}

	modal.modal( 'show' );
} )( jQuery );


// WEBPACK FOOTER //
// ./scripts/components/unshippable.js